Ext.define('SA.ScatterPlotEditController', {
    constructor({model, activeState}) {
        this.model = model;
        this.activeState = activeState;

        this.modelLocations = new SA.EditModelLocations(model);
        this.modelAttributes = new SA.EditModelAttributes(model);

        this.validator = SA.EditValidator.forModel(this.model);
        this.validator.requireLocation();
        this.validator.addRuleType(SA.EditScatterPlotAttributesRequiredRule);
        this.validator.addRuleType(SA.EditScatterPlotGeographicUnitRequiredRule);

        this.locationsPanel = SA.EditPanelBuilder.forLocations().withRadios().build();

        this.attributesPanel = SA.EditPanelBuilder
            .forAttributes()
            .setSubheader(SA.ScatterPlotAttributesPanelSubheader.create())
            .setItemFactory(id => Ext.widget({xtype: 'scatter-plot-attributes-panel-item', dataId: id}))
            .build();

        this.view = Ext.widget({xtype: 'edit-view', panels: [this.locationsPanel.getView(), this.attributesPanel.getView()]});

        this.initEvents();
    },

    initEvents() {
        this.modelObserver = SA.EditModelObserver.create(this.model, this.refresh, this);
        this.modelObserver.observeName();
        this.modelObserver.observeLocations();
        this.modelObserver.observeAttributes();

        this.activeState.onActive(this.refresh, this);
        this.activeState.onChange(active => this.modelObserver.setEnabled(active));

        this.sidebarObserver = new SA.SidebarObserver(this.activeState);
        this.sidebarObserver.onUseLocation(this.onSidebarUseLocation, this);
        this.sidebarObserver.onUseAttribute(this.onSidebarUseAttribute, this);

        this.view.onDoneClick(() => SA.AppController.showProjectView(this.model));

        this.locationsPanel.onItemChange(this.onLocationsPanelItemChange, this);
        this.attributesPanel.onItemChange(this.onAttributesPanelItemChange, this);
    },

    getView() {
        return this.view;
    },

    onAttributesPanelItemChange({axis, attribute, checked}) {
        this.model.setAttributeForAxis({axis, attribute: checked ? attribute : null});
        this.model.save();
    },

    onLocationsPanelItemChange(radio) {
        this.model.setLocation(radio.getDataId());
        this.model.save();
    },

    onSidebarUseAttribute(id) {
        this.view.scrollToEl(() => this.attributesPanel.getEnabledItemEl(id));
    },

    onSidebarUseLocation(id) {
        this.view.scrollToEl(() => this.locationsPanel.getEnabledItemEl(id));
    },

    refresh() {
        this.view.setViewName(this.model.getName());
        this.view.setWarningMessage(this.validator.getFirstMessage());

        this.locationsPanel
            .setEnabledIds(this.modelLocations.getSupported())
            .setDisabledIds(this.modelLocations.getUnsupported())
            .eachItem(item => item.refreshLabel())
            .eachEnabledItem(item => item.setCheckedSuppressed(this.modelLocations.isSelected(item.getDataId())));

        this.attributesPanel
            .setEnabledIds(this.modelAttributes.getSupported())
            .setDisabledIds(this.modelAttributes.getUnsupported())
            .eachEnabledItem(item => {
                var isXAttribute = item.getDataId() === this.model.getXAttribute(),
                    isYAttribute = item.getDataId() === this.model.getYAttribute();

                item.setState({x: isXAttribute, y: isYAttribute});
            });
    }
});
